export default {
  supportSettings(state) {
    return state.supportSettings;
  }
};
